import type { FC } from 'react';
import React from 'react';

import type { IProgressWrapper } from '../models/progress-models';

export const HorizontalProgressWrapper: FC<IProgressWrapper> = ({
    Layout,
    Progress,
    children,
    progressProps,
}) => {
    return (
        <>
            <Progress {...progressProps} />
            <Layout contentWidth="564px" hasPadding={false}>
                {children}
            </Layout>
        </>
    );
};
